const API_URLS = [
  process.env.REACT_APP_API_URL_1,
  // process.env.REACT_APP_API_URL_2,
  // process.env.REACT_APP_API_URL_3,
  // process.env.REACT_APP_API_URL_4,
  // process.env.REACT_APP_API_URL_5,
  // process.env.REACT_APP_API_URL_6,
  // process.env.REACT_APP_API_URL_7,
  // process.env.REACT_APP_API_URL_8,
  // process.env.REACT_APP_API_URL_9,
  // process.env.REACT_APP_API_URL_10,
].filter(Boolean);

if (API_URLS.length === 0) {
  throw new Error("No API URLs configured");
}

// Con trỏ round-robin
let currentIndex = Math.floor(Math.random() * API_URLS.length);

function getNextApi() {
  const api = API_URLS[currentIndex];
  currentIndex = (currentIndex + 1) % API_URLS.length;
  return api;
}

export async function fetchWithFallback(path, options = {}) {
  const tried = new Set();
  let lastError;

  while (tried.size < API_URLS.length) {
    const baseUrl = getNextApi();

    // tránh thử lại cùng 1 server
    if (tried.has(baseUrl)) {
      continue;
    }

    tried.add(baseUrl);

    try {
      const res = await fetch(`${baseUrl}${path}`, options);

      // Thành công
      if (res.ok) {
        return res;
      }

      // quota hết hoặc lỗi server -> thử server khác
      if (res.status === 429 || res.status >= 500) {
        console.warn(`${baseUrl} => ${res.status}`);
        continue;
      }

      // 400 401 403... trả luôn
      return res;
    } catch (err) {
      console.warn(`${baseUrl} => fetch failed`);
      lastError = err;
    }
  }

  throw lastError || new Error("All API unavailable");
}